import dva from 'dva'
import createLoading from 'dva-loading'
import { handler } from '@/common/handleUncaughtError'

const app = dva({ onError: handler })

app.use(createLoading())

export default app
